import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceita = '/service/planejamentoEstrategico/indicadores/'

class TemaIndicadoresService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getTemas() {
        return this.conex.get(urlReceita + 'temas/')
    }
}

export default TemaIndicadoresService
